import { Delete, Get, Post, Put } from "../index";

export const createEnquiryAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/enquiry/create`, payload });
};

export const getAllEnquiryAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string,
  filters?: {
    companyName?: string;
    eventType?: any;
    eventDate?: any;
    datePreference?: string;
    budgetFrom?: number;
    budgetTo?: number;
    status: string;
  }
) => {
  let url = `v1/enquiry/client-list`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }

  // if (filters?.companyName) {
  //   url += `?companyName=${encodeURIComponent(filters.companyName)}`;
  // }
  // if (filters?.eventType) {
  //   url += `?eventType=${encodeURIComponent(filters.eventType)}`;
  // }
  // if (filters?.eventDate) {
  //   url += `?eventDate=${encodeURIComponent(filters.eventDate)}`;
  // }

  // if (filters?.datePreference) {
  //   url += `?datePreference=${encodeURIComponent(filters.datePreference)}`;
  // }
  // if (filters?.budget) {
  //   url += `?budget=${encodeURIComponent(filters.budget)}`;
  // }
  // if (filters?.status) {
  //   url += `?status=${encodeURIComponent(filters.status)}`;
  // }

  const body = {
    ...payload,
    companyName: filters?.companyName,
    eventType: filters?.eventType,
    eventDate: filters?.eventDate,
    datePreference: filters?.datePreference,
    budgetFrom: filters?.budgetFrom,
    budgetTo: filters?.budgetTo,
    status: filters?.status,
  };

  return Post({ url, payload: body });
};
export const getAllEnquiryListAPI = async (
  payload?: { index: number; limit: number; eventId?: string; search?: string },
  // searchValue?: string,
  filters?: {
    companyName?: string;
    eventType?: any;
    eventDate?: any;
    datePreference?: string;
    budgetFrom?: number;
    budgetTo?: number;
    status: string;
  }
) => {
  let url = `v1/enquiry/clientlist`;

  // if (searchValue) {
  //   url += `?search=${encodeURIComponent(searchValue)}`;
  // }

  const body = {
    ...payload,
    companyId: filters?.companyName,
    eventType: filters?.eventType,
    eventDate: filters?.eventDate,
    datePreference: filters?.datePreference,
    budgetFrom: filters?.budgetFrom,
    budgetTo: filters?.budgetTo,
    status: filters?.status,
  };

  return Post({ url, payload: body });
};

export const getAllEventDocsAPI = async (payload: {
  index: number;
  limit: number;
  search?: string;
}) => {
  return Post({ url: `v1/enquiry/getAllEventDocs`, payload });
};

export const getCustomerByIDAPI = async (id: any) => {
  // console.log(id,"id>>>>");
  return Get({ url: `v1/customer/${id}` });
};
export const getemployeeByIDAPI = async (id: any) => {
  return Get({ url: `v1/employee/${id}` });
};
// Get All Sales Manager
export const getAllSalesManager = async () => {
  return Get({ url: `v1/enquiry/sales-managers` });
};

export const getAllCompanyAPI = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  let url = `v1/company`;
  if (params?.page != null || params?.limit != null || params?.search != null) {
    const query = new URLSearchParams();
    if (params.page != null) query.append("page", String(params.page));
    if (params.limit != null) query.append("limit", String(params.limit));
    query.append("search", params.search ?? "");
    url += `?${query.toString()}`;
  }
  return Get({ url });
};
export const getCompanyByIDAPI = async (id:any) => {
  return Get({ url: `v1/company/${id}` });
};

export const updateCompanyAPI = async (id: any, payload: any) => {
  return Put({ url: `v1/company/update/${id}`, payload });
};

export const createCompanyAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/company/create`, payload });
};

export const getAllAssociatedEventAPI = async (customerID: any) => {
  // console.log(customerID, "customerID>>>>");
  return Get({ url: `v1/enquiry/customer-events/${customerID}` });
};
export const updateAssignedToCompanyAPI = async (
  customerId: any,
  payload: any
) => {
  // console.log(customerId, "customerId>>>>", payload, "CompanyId");
  return Put({ url: `v1/customer/update/${customerId}`, payload });
};
export const createCustomerAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/customer/create`, payload });
};

export const getAllCustomerAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string
) => {
  let url = `v1/customer`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }
  return Post({ url, payload: payload });
};
export const getAllCustomerByCompanyAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string,
  companyID?: any
) => {
  let url = `v1/customer/customerByCompany/${companyID}`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }
  return Post({ url, payload: payload });
};


  export const updateCustomerAPI = async (customerId:any,payload:any) => {
    // console.log(customerId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customer/update/${customerId}`,payload})
  }
  
  export const createRequirementAPI = async (payload: any) => {
    // console.log(payload,"payload>>>>>");
    return Post({ url: `v1/customerRequirement/create`, payload })
  }
  export const updateInitalRequirementAPI = async (RequirementId:any,payload:any) => {
    // console.log(RequirementId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customerRequirement/updateinitialAddRequirements/${RequirementId}`,payload})
  }
  export const updateRequirementAPI = async (RequirementId:any,payload:any) => {
    // console.log(RequirementId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customerRequirement/update/${RequirementId}`},payload)
  }
  export const editRequirementByIdAPI = async (RequirementId:any,payload:any) => {
    // console.log(RequirementId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customerRequirement/updateSubRequirement/${RequirementId}`,payload})
  }

  export const deleteRequirementByIdAPI = async (RequirementId:any) => {
    // console.log(RequirementId,"customerId>>>>");
    return Delete({ url: `v1/customerRequirement/deleteSubRequirement/${RequirementId}`})
  }

  export const removeShortlistedServicesAPI = async (payload: {
    subRequirementId: string;
    serviceId: string;
    eventId: string;
  }) => {
    return Delete({
      url: `v1/customerRequirement/removeShortlistedServices`,
      payload,
    });
  };

  export const getShortlistedServicesAPI = async (payload: {
    type?: "supplier" | "venue";
    eventId: string;
    status?: string;
    notFromSuggested?: boolean;
  }) => {
    return Post({
      url: `v1/customerRequirement/getShortlistedServices`,
      payload,
    });
  };

  export const createShortlistedServicesAPI = async (payload: {
    eventId: string;
    serviceId: string;
    type: "supplier" | "venue";
    description?: string;
  }) => {
    return Post({
      url: `v1/customerRequirement/createShortlistedServices`,
      payload,
    });
  };

  export const updateShortlistedServiceStatusAPI = async (
    id: string,
    payload: { status: string },
  ) => {
    return Put({
      url: `v1/customerRequirement/updateShortlistedServiceStatus/${id}`,
      payload,
    });
  };

  export const getRequirementByIDAPI = async (RequirementId:any) => {
    return Post({ url: `v1/customerRequirement/view/${RequirementId}`})
  }

  export const getAllRequirementAPI = async () => {
    return Post({ url: `v1/customerRequirement/getAll`})
  }

  export const getAllProposalByIDAPI = async (eventId:any,payload?: { index: number; limit: number; }) => {
    // console.log(eventId,"eventId>>>>>");
    return Post({ url: `v1/proposal/event/${eventId}`,payload})
  }

  export const getEventByIDAPI = async (eventId:any) => {
    // console.log(eventId,"eventId>>>>>");
    return Get({ url: `v1/event/view/${eventId}`})
  }
  export const getSelectedEventByVenueAPI = async (eventId:any,payload:any) => {
    // console.log(eventId,"eventId>>>>>");
    return Post({ url: `v1/event/viewVenues/${eventId}`,payload})
  }
  export const getSelectedEventBySupplierAPI = async (eventId:any,payload:any) => {
    // console.log(eventId,"eventId>>>>>");
    return Post({ url: `v1/event/viewSuppliers/${eventId}`,payload})
  }
  export const sendProposalMailAPI = async (payload:any) => {
    // console.log(payload,"payload>>>>>");
    return Post({ url: `v1/proposal/send-proposal-mail`,payload},"multipart/form-data")
  }
  export const sendProposalMailTrackingAPI = async (eventId:any,payload:any) => {
    // console.log(payload,"payload>>>>>",eventId,"eventId>>>>");
    return Put({ url: `v1/event/mailtracking/${eventId}`,payload})
  }
  export const getProposalMailTrackingAPI = async (eventId:any) => {
    // console.log(eventId,"eventId>>>>");
    return Get({ url: `v1/event/viewMailtracking/${eventId}`,})
  }
  export const updateEventAPI = async (eventId:any,payload:any) => {
    // console.log(payload,"payload>>>>>",eventId,"eventId>>>>");
    return Put({ url: `v1/enquiry/update-event/${eventId}`,payload})
  }
  
//TIMING SERVICES
const timingDateKey = (value?: string) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(0, 10);
};

export const normalizeTimingList = (data: any[]) => {
  const groups = new Map<string, any>();
  (Array.isArray(data) ? data : []).forEach((item) => {
    const key = timingDateKey(item?.event_date);
    if (!key) return;
    if (!groups.has(key)) {
      groups.set(key, {
        _id: item?._id,
        event_date: item?.event_date,
        eventId: item?.eventId,
        details: [],
      });
    }
    const group = groups.get(key);
    if (Array.isArray(item?.details) && item.details.length) {
      item.details.forEach((detail: any, index: number) => {
        group.details.push({
          _id: detail?._id,
          event_time: detail?.event_time || "",
          description: detail?.description || "",
          position: Number(detail?.position) || index + 1,
        });
      });
    } else if (item?.event_time || item?.description) {
      group.details.push({
        _id: item?._id,
        event_time: item?.event_time || "",
        description: item?.description || "",
        position: Number(item?.position) || group.details.length + 1,
      });
    }
  });
  return Array.from(groups.values()).map((group) => ({
    ...group,
    details: [...group.details].sort(
      (left, right) => (left.position || 0) - (right.position || 0),
    ),
  }));
};

export const postTiming = async (payload: {
  event_date: string;
  event_time: string;
  description: string;
  eventId: string;
}) => {
  return Post({ url: `v1/timing/create`, payload });
};

export const getAllTime = async (eventId: string) => {
  const response: any = await Post({
    url: `v1/timing`,
    payload: { eventId },
  });
  if (response?.status === 200 && Array.isArray(response?.data)) {
    return { ...response, data: normalizeTimingList(response.data) };
  }
  return response;
};

export const deleteTiming = async (id: string) => {
  return Delete({ url: `v1/timing/delete/${id}` });
};

export const changeTimingPosition = async (
  payload: { _id: string; position: number }[],
) => {
  return Put({ url: `v1/timing/changePosition`, payload });
};

export const updateTiming = async (
  id: string,
  payload: {
    event_date: string;
    event_time: string;
    description: string;
    eventId: string;
  },
) => {
  return Put({ url: `v1/timing/update/${id}`, payload });
};
export const updateVenueShortlistStatus=async(eventId:string,payload:any)=>{
  return Put({ url: `/v1/shortlist/venue/${eventId}`,payload});
}
export const updateSupplierShortlistStatus=async(eventId:string,payload:any)=>{
  return Put({ url: `/v1/shortlist/supplier/${eventId}`,payload});
}

export const getAllShorlisted = async (eventId:string) => {
  return Get({ url: `v1/shortlist/list/${eventId}` });
};
export const getViewVenueShorlistedAPI = async (eventId:string,payload:any) => {
  return Post({ url: `v1/event/viewShortlistedVenues/${eventId}`,payload});
};
export const getViewSupplierShorlistedAPI = async (eventId:string,payload:any) => {
  return Post({ url: `v1/event/viewShortlistedSuppliers/${eventId}`,payload});
};

export const uploadClientTemplateAPI = async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/eventTemplate/create`,payload},"multipart/form-data")
}
export const getUploadClientTemplateAPI = async (eventId:any) => {
  // console.log(eventId,"eventId>>>>>");
  return Get({ url: `v1/eventTemplate/viewEventTeamplate/${eventId}`})
}


//API FOR ASSIGN PLANNER TO EVENT
export const updatePlannerToEvent=async(eventID:string,payload:any)=>{
  return Put({url:`v1/enquiry/assign-planner-to-event/${eventID}`,payload})
}

//API FOR ASSIGN SALES TO EVENT
export const updateSalesToEvent=async(eventID:string,payload:any)=>{
  return Put({url:`v1/enquiry/assign-sales-to-event/${eventID}`,payload})
}

export const getAllSuggestedSupplierAPI = async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/supplier/getAllSuggestedSupplierDetails`,payload})
}

export const getAllSuggestedVenueAPI = async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/venue/getAllSuggestedVenueDetails`,payload})
}

export const createCompanyEmployeeAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/employee/create`, payload });
};

export const updateEmployeeByCompanyAPI=async(EmployeeID:string,payload:any)=>{
  return Put({url:`v1/employee/${EmployeeID}`,payload})
}

export const deleteEmployeeAPI = async (employeeId: string) => {
  return Delete({ url: `v1/employee/${employeeId}` });
};

export const getAllEmployeeByCompanyAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string,
  companyID?: any,
  EventID?:any
) => {
  let url = `/v1/employee/by-company-event/${companyID}/event/${EventID}`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }
  return Post({ url, payload: payload });
};

export const getAllB2BEmployeeAPI = async (eventId:any) => {
  console.log(eventId,"eventId>>>>>");
  return Get({ url: `v1/employee/b2b/${eventId}`})
}


export const getAllB2CEmployeeAPI = async (
  payload?: { index: number; limit: number,searchValue?: string },
  
) => {
  let url = `/v1/employee/getAllEmployees`;

  // if (searchValue) {
  //   url += `?search=${encodeURIComponent(searchValue)}`;
  // }
  return Post({ url, payload: payload });
};

export const createProposalAPI= async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/proposal/create`,payload})
}

export const getServiceProposalHistoryAPI = async (
  subRequirementId: string,
  serviceId?: string,
  pagination?: { index: number; limit: number },
) => {
  const params = new URLSearchParams();
  if (serviceId) params.set("supplierId", serviceId);
  params.set("index", String(pagination?.index ?? 1));
  params.set("limit", String(pagination?.limit ?? 5));
  return Get({
    url: `v1/proposal/serviceProposal/${subRequirementId}?${params.toString()}`,
  });
};

export const getReturnProposalQuotationAPI = async (proposalId: string) => {
  return Get({ url: `v1/proposal/getback/${proposalId}` });
};

export const getProposalByIdAPI = async (proposalId:any) => {
  // console.log(proposalId,"proposalId>>>>>");
  return Get({ url: `v1/proposal/${proposalId}`})
}

export const updateProposalStatusAPI=async(proposalId:string,payload:any)=>{
  return Put({url:`v1/proposal/status/${proposalId}`,payload})
}

export const updateProposalAPI=async(proposalId:string,payload:any)=>{
  return Put({url:`v1/update/${proposalId}`,payload})
}

// Pricing API

export const createPricingAPI= async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/eventBill/create`,payload})
}

export const addBillingServiceAPI = async (eventId: string, payload: any) => {
  return Post({
    url: `v1/eventBill/${eventId}/addBillingService`,
    payload,
  });
};

export const updatePricingAPI=async(priceID:string,payload:any)=>{
  return Put({url:`v1/eventBill/update/${priceID}`,payload})
}

export const updateSpecificBillAPI = async (lineId: string, payload: any) => {
  return Put({ url: `v1/eventBill/updateSpecificBill/${lineId}`, payload });
};

export const getPricingByIdAPI = async (priceID:any,eventID:any) => {
  // console.log(priceID,"priceID>>>>>",eventID,"eventID>>>>");
  return Get({ url: `v1/eventBill/view/${priceID ? priceID : "_id"}?eventId=${eventID}`})
}

export const getAllEventBillsAPI = async (payload: { eventId: string }) => {
  return Post({ url: `v1/eventBill/getAll`, payload });
};

export const normalizeEventBills = (billsResponse: any) => {
  const payload = billsResponse?.data ?? billsResponse;
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === "object") {
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.eventBillingDetails) || payload._id) {
      return [payload];
    }
    if (payload.data && typeof payload.data === "object") {
      const nested = payload.data;
      if (Array.isArray(nested.eventBillingDetails) || nested._id) {
        return [nested];
      }
    }
  }
  return [];
};

const readEntityId = (value: any) => {
  if (value == null || value === "") return "";
  if (typeof value === "string" || typeof value === "number") return String(value);
  return String(value._id || value.id || "");
};

const addEntityId = (ids: Set<string>, value: any) => {
  const id = readEntityId(value);
  if (id) ids.add(id);
};

export const isBillingDetailInvoiced = (detail: any) =>
  detail?.invoiced === true || detail?.invoiced === "true";

const collectInvoicedDetailIds = (ids: Set<string>, detail: any) => {
  addEntityId(ids, detail?.shorlistServiceId);
  addEntityId(ids, detail?.shortlistServiceId);
  addEntityId(ids, detail?.supplierId);
  const shortlist = detail?.shorlistServiceId ?? detail?.shortlistServiceId;
  if (shortlist && typeof shortlist === "object") {
    addEntityId(ids, shortlist.serviceId);
    addEntityId(ids, shortlist.supplierId);
    addEntityId(ids, shortlist.venueId);
  }
};

export const getInvoicedShortlistServiceIds = (billsResponse: any) => {
  const bills = normalizeEventBills(billsResponse);
  const invoicedIds = new Set<string>();

  bills.forEach((bill: any) => {
    const details = Array.isArray(bill?.eventBillingDetails)
      ? bill.eventBillingDetails
      : [];
    details.forEach((detail: any) => {
      if (!isBillingDetailInvoiced(detail)) return;
      collectInvoicedDetailIds(invoicedIds, detail);
    });
  });

  return invoicedIds;
};

export const hasInvoicedService = (
  invoicedIds: Set<string>,
  ...candidates: any[]
) => candidates.some((candidate) => invoicedIds.has(readEntityId(candidate)));

const collectEntityIds = (value: any) =>
  (Array.isArray(value) ? value : []).map(readEntityId).filter(Boolean);

const serviceTypeOf = (value: any): "venue" | "supplier" | "" => {
  const type = String(value || "").trim().toLowerCase();
  if (type === "venue" || type === "supplier") return type;
  return "";
};

export const getInvoicedSuggestedServices = (
  billsResponse: any,
  userRequirements: any[] = [],
) => {
  const bills = normalizeEventBills(billsResponse);
  const requirements = Array.isArray(userRequirements) ? userRequirements : [];
  const invoiced: {
    subRequirementId: string;
    serviceId: string;
    serviceType: "venue" | "supplier";
  }[] = [];

  const pushInvoiced = (
    subRequirementId: string,
    serviceId: string,
    serviceType: "venue" | "supplier",
  ) => {
    if (!subRequirementId || !serviceId) return;
    const alreadyListed = invoiced.some(
      (item) =>
        item.subRequirementId === subRequirementId &&
        item.serviceId === serviceId &&
        item.serviceType === serviceType,
    );
    if (!alreadyListed) {
      invoiced.push({ subRequirementId, serviceId, serviceType });
    }
  };

  bills.forEach((bill: any) => {
    const details = Array.isArray(bill?.eventBillingDetails)
      ? bill.eventBillingDetails
      : [];
    details.forEach((detail: any) => {
      if (!isBillingDetailInvoiced(detail)) return;
      const shortlist = detail?.shorlistServiceId ?? detail?.shortlistServiceId;
      const detailType = serviceTypeOf(detail?.supplierType);
      if (shortlist && typeof shortlist === "object") {
        const subRequirementId = readEntityId(shortlist.subRequirementId);
        const serviceId =
          readEntityId(shortlist.serviceId) || readEntityId(detail?.supplierId);
        const serviceType = serviceTypeOf(shortlist.serviceType) || detailType;
        if (subRequirementId && serviceId && serviceType) {
          const requirement = requirements.find(
            (item: any) => readEntityId(item?._id) === subRequirementId,
          );
          const suggestedIds = requirement
            ? serviceType === "venue"
              ? collectEntityIds(requirement.suggestedVenue)
              : collectEntityIds(requirement.suggestedSupplier)
            : [];
          if (suggestedIds.includes(serviceId)) {
            pushInvoiced(subRequirementId, serviceId, serviceType);
            return;
          }
        }
      }

      const entityId =
        readEntityId(detail?.supplierId) ||
        (shortlist && typeof shortlist === "object"
          ? readEntityId(shortlist.serviceId)
          : "");
      if (!entityId) return;
      requirements.forEach((requirement: any) => {
        const subRequirementId = readEntityId(requirement?._id);
        if (collectEntityIds(requirement?.suggestedVenue).includes(entityId)) {
          pushInvoiced(subRequirementId, entityId, "venue");
        }
        if (collectEntityIds(requirement?.suggestedSupplier).includes(entityId)) {
          pushInvoiced(subRequirementId, entityId, "supplier");
        }
      });
    });
  });

  return invoiced;
};

export const deletePricingByIdAPI = async (priceID:string) => {
  return Delete({ url: `v1/eventBill/delete/${priceID}` });
};

export const deleteSpecificBillAPI = async (lineId: string) => {
  return Delete({ url: `v1/eventBill/deleteSpecificBill/${lineId}` });
};

export const updateEnquiryAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/update/${eventId}`,payload})
}

export const deleteEnquiriesAPI = async (eventIds: string[]) => {
  return Post({ url: `v1/event/delete`, payload: { eventIds } });
};

export const updateSuggestedVenuesAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/deleteSuggestedVenues/${eventId}`,payload})
}

export const updateSuggestedSuppliersAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/deleteSuggestedSuppliers/${eventId}`,payload})
}

export const eventStatusUpdateAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/eventStatusUpdate/${eventId}`,payload})
}

export const sendRequirementProposalMailAPI = async (payload: {
  _id: string;
  isUpdated: boolean;
  venueId?: string;
  supplierId?: string;
  mailContent?: string;
}) => {
  return Post({
    url: `v1/event/requirementProposal`,
    payload,
  });
}


  

  




  

  
  


  
